import React from 'react';

import { ErrorMessage } from '@change/ds-forms';

import { useValidationErrorMessage } from './hook/useValidationErrorMessage';

export function ValidationErrorMessage(): React.JSX.Element {
	const { errorMessage } = useValidationErrorMessage();
	return (
		<>
			{errorMessage && (
				<div className="mt-2">
					<ErrorMessage data-qa="invalid-amount-error">{errorMessage}</ErrorMessage>
				</div>
			)}
		</>
	);
}
